import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { IconComponent } from './icon/icon.component';
import { CommonModule } from '@angular/common';
// import { Wrapper } from './wrapper.component';

@Component({
    selector: 'search-bar',
    imports: [IconComponent, CommonModule],
    template: `
        <div [class]="'search_bar' + (gray ? ' gray' : '')">
            <icon class="search" matIcon="search"></icon>
            <input #searchInput [ngClass]="{gray: gray}" [placeholder]="placeholder" (keyup)="search($event.target['value'])"  (keydown)="$event.stopPropagation()" />
            <icon class="closeSearch" *ngIf="value" (click)="clearSearchTerm()" matIcon="close"></icon>
        </div>
`,
    styles: [`
.search_bar { width:100%; height:30px; display:flex; align-items: center; position:relative; border-radius: 15px;
  padding: 0px 5px 0px 0; }
.search_bar icon { font-size: 18px; color: #c0c0c0; height: 18px; }
input::placeholder { color: #c0c0c0; }
.search_bar.gray { height: 35px; padding: 0px; }
input.gray { background: #EEF2F5; }
.search_bar icon:hover { color: #707070; }
.search_bar icon.search { position: absolute; left: 5px; }
.search_bar icon.closeSearch { position: absolute; right: 3px; cursor: pointer; }
.search_bar icon.close:hover { color: #707070; }
.search_bar input { font-size: 14px; color:#41474F; border:0; width: 100%; height: 100%; outline: none; padding: 0 10px 0 25px; border-radius:15px; }
`],
    standalone: true,
})
export class SearchBarComponent implements OnInit, OnDestroy {// extends Wrapper<SearchBarComponent> 
    @Input() bg = '#EEF2F5';
    @Input() placeholder = ""
    @Input() gray = false
    @Input() debounceTime = 400
    @Output() keyword: EventEmitter<string> = new EventEmitter();
    @ViewChild('searchInput', { static: true }) searchInput: ElementRef<HTMLInputElement>
    searchKey: Subject<string> = new Subject<string>();
    value = '';
    $destroy: Subject<boolean> = new Subject<boolean>();
    
    search(keyword) {
      if (this.debounceTime) {
        this.searchKey.next(keyword)
      } else {
        this.keyword.emit(keyword)
        this.value = keyword
      }
    }

    getCurrentSearchValue() {
      return this.value
    }

    setCurrentSearchValue(searchTerm: string) {
      this.searchInput.nativeElement.value = searchTerm
    }
    
    ngOnInit() {
      this.searchKey.pipe(debounceTime(this.debounceTime)).pipe(takeUntil(this.$destroy)).subscribe(key => {
        this.value = key
        this.keyword.emit(key)
      })
    }

    clear() {
      this.searchInput.nativeElement.value = ''
    }

    clearSearchTerm() {
      this.searchKey.next('')
      this.clear()
    }

    focus() {
      this.searchInput.nativeElement.focus()
    }

    ngOnDestroy() {
      this.$destroy.next(true)
      this.$destroy.complete()
    }
}
